export const array_reverse = (array, preserve_keys) => {
  var isArray = Object.prototype.toString.call(array) === "[object Array]",
    tmp_arr = preserve_keys ? {} : [],
    key;

  if (isArray && !preserve_keys) {
    return array.slice(0).reverse();
  }

  if (preserve_keys) {
    var keys = [];
    for (key in array) {
      keys.push(key);
    }

    var i = keys.length;
    while (i--) {
      key = keys[i];
      tmp_arr[key] = array[key];
    }
  } else {
    for (key in array) {
      tmp_arr.unshift(array[key]);
    }
  }

  return tmp_arr;
};
export const bcmod = (left_operand, modulus) => {
  // John was here!
  // Key was here!
  var i, d;
  function split(operand) {
    var parts = operand.split(".");
    var i = parts[0];
    var d = "0." + (parts.length > 1 ? parts[1] : "0");
    return { i: i, d: d };
  }
  //modulus = Math.round( parseFloat( modulus ) );
  modulus = parseFloat(modulus);
  modulus = Math.abs(modulus);
  if (modulus === 0) {
    return null;
  }
  var take = 4;
  var modulus_limit = Math.pow(10, take);
  if (modulus >= modulus_limit) {
    throw new Error("Modulus cannot be " + modulus_limit + " or greater.");
  }
  var result = 0;
  var r = split(left_operand);
  i = r.i;
  d = r.d;
  var read_length = 0;
  function read() {
    read_length = i.length < take ? i.length : take;
    var result = i.substr(0, take);
    i = i.substr(take);
    return result;
  }
  function round(value) {
    var units = "0.0000000000000000";
    function get_chars(s) {
      var result = [];
      for (var j = 0, jl = s.length; j < jl; j++) {
        result.unshift(s.charAt(j));
      }
      return result;
    }
    value = value.toString();
    var r = split(value);
    var d_chars = get_chars(r.d.substring(0, units.length));
    var carry = 0;
    for (var ci = 0, cl = d_chars.length; ci < cl; ci++) {
      var c = d_chars[ci];
      if (!/^[0-9]$/.test(c)) {
        break;
      }
      if (ci === 0 && cl >= units.length) {
        carry = Math.round(parseFloat("0." + c));
        d_chars[ci] = "0";
      } else {
        var v = parseInt(c) + carry;
        if (v >= 10) {
          carry = 1;
          v -= 10;
        } else {
          carry = 0;
        }
        d_chars[ci] = v.toString();
      }
    }
    var result =
      (parseInt(r.i) + carry).toString() +
      array_reverse(d_chars.slice(0, -1))
        .join("")
        .replace(/[0.]*$/, "");
    return result;
  }
  do {
    var n = parseInt(read());
    result = (result * Math.pow(10, read_length) + n) % modulus;
    var temp = parseFloat(round(result));
    if (temp - modulus >= 0) {
      temp -= modulus;
      result = temp;
    }
  } while (i.length > 0);
  result += parseFloat(d);
  var test = result - modulus;
  result = test < 0 ? result : test;
  result = round(result);
  return result;
};
